var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-page"},[_vm._t("navbar"),_vm._v(" "),_c('div',{ref:"content",staticClass:"page-content",on:{"scroll":_vm.scroll}},[_vm._t("default")],2),_vm._v(" "),_vm._t("tabbar")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30b1638e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/UnvPage.vue
// module id = null
// module chunks = 